import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelSettingsCentralMappingTablesCellsThInventorySignature {
  Args: {};
}

const HotelSettingsCentralMappingTablesCellsThInventory = <template>
  <div class="flex flex-row gap-100">
    {{t "settings.central_mapping.mapping.inventory"}}

    <GeneralIconWithTooltip
      @color="default"
      @iconName="circle-information-outline"
      @size="small"
      @tooltipContent={{t "settings.central_mapping.mapping.inventory.tooltip"}}
    />
  </div>
</template> satisfies TOC<HotelSettingsCentralMappingTablesCellsThInventorySignature>;

export default HotelSettingsCentralMappingTablesCellsThInventory;
